<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">AGV任务看板</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      config: {
        header: ['任务号', '起点地址', '终点地址', '状态'],
        data: [
          ['组件1', 'dev-1', "<span  class='colorGrass'>↑75%</span>", "ddd"],
          ['组件2', 'dev-2', "<span  class='colorRed'>↓33%</span>"],
          ['组件3', 'dev-3', "<span  class='colorGrass'>↑100%</span>"],
          ['组件4', 'rea-1', "<span  class='colorGrass'>↑94%</span>"],
          ['组件5', 'rea-2', "<span  class='colorGrass'>↑95%</span>"],
          ['组件6', 'fix-2', "<span  class='colorGrass'>↑63%</span>"],
          ['组件7', 'fix-4', "<span  class='colorGrass'>↑84%</span>"],
          ['组件8', 'fix-7', "<span  class='colorRed'>↓46%</span>"],
          ['组件9', 'dev-2', "<span  class='colorRed'>↓13%</span>"],
          ['组件10', 'dev-9', "<span  class='colorGrass'>↑76%</span>"]
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        index: true,
        columnWidth: [50],
        align: ['center']
      }
    }
  },
  mounted() {
    this.changeTiming()
  },
  methods: {
    changeTiming() {
        this.changeNumber()
      setInterval(() => {
        this.changeNumber()
      },60000)
    },
    changeNumber() {
      axios.post("http://192.168.11.58:8098/api/ToWMS/GetAGVTaskData", {
      // axios.post("http://127.0.0.1:8098/api/ToWMS/GetAGVTaskData", {
        MainData: {
          AGVName: "组装AGV调度"
        }
      }).then((res) => {
   
        console.log(res);
        if (res.data.status) {
          let agvs = res.data.data
          let GetAGVTaskData = []
          agvs.forEach(element => {
            let data = [element.agv_tasknum,"<span  class='colorRed'>"+element.agv_fromaddress+"</span>" , "<span  class='colorGrass'>" + element.agv_toaddress + "</span>", element.agv_taskstate]
            GetAGVTaskData.push(data)
          });
          this.config.data = GetAGVTaskData
          this.config = {
            header: ['任务号', '起点地址', '终点地址', '状态'],
            data: GetAGVTaskData,
            rowNum: 10, //表格行数
            headerHeight: 35,
            headerBGC: '#0f1325', //表头
            oddRowBGC: '#0f1325', //奇数行
            evenRowBGC: '#171c33', //偶数行
            index: true,
            columnWidth: [50],
            align: ['center']
          }
        }
        else {
          this.config = {
            header: ['任务号', '起点地址', '终点地址', '状态'],
            data: [
              ["<span  class='colorRed'>暂无数据</span>","<span  class='colorRed'>暂无数据</span>","<span  class='colorRed'>暂无数据</span>","<span  class='colorRed'>暂无数据</span>"],
            ],
            rowNum: 7, //表格行数
            headerHeight: 35,
            headerBGC: '#0f1325', //表头
            oddRowBGC: '#0f1325', //奇数行
            evenRowBGC: '#171c33', //偶数行
            index: true,
            columnWidth: [50],
            align: ['center']
          }
        }
      }).catch((res) => {
        console.log(res)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$box-height: 700px;
$box-width: 100%;

#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;

  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }

  .text {
    color: #c3cbde;
  }

  .body-box {
    border-radius: 10px;
    overflow: hidden;

    .dv-scr-board {
      width: 100%;
      height: 435px;
    }
  }
}
</style>
